/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState, useEffect } from 'react';
import PaymentsAPI from 'api/PaymentsAPI';
import { Modal, Drawer } from '@mui/material';
import CancelAPIModal from './CancelAPIModal';
import RenewAPIPlanModal from './RenewAPIPlanModal';
import APISubMgmtModal from './APISubMgmtModal';
import APIEditPlan from './APIEditPlan';
import MeterCard from './MeterCard';

interface IAPIPlanManagementProps {
  cusId: string;
  cur_user: any;
  apiSubs: any;
  handleTabChange: any;
}

const APIPlanManagement: React.FC<IAPIPlanManagementProps> = ({ handleTabChange, apiSubs, cusId, cur_user }) => {
  const [ entityCancelMode, setEntityCancelMode ] = useState<any>({ active: false, cancelNow: true });
  const [ productsCancelMode, setProductsCancelMode ] = useState<any>({ active: false, cancelNow: true });
  const [ automationsCancelMode, setAutomationsCancelMode ] = useState<any>({ active: false, cancelNow: true });
  const [ tier2CancelMode, setTier2CancelMode ] = useState<any>({ active: false, cancelNow: false });
  const [ tier3CancelMode, setTier3CancelMode ] = useState<any>({ active: false, cancelNow: false });
  const [ entityMgmtOpen, setEntityMgmtOpen ] = useState(false);
  const [ productsMgmtOpen, setProductsMgmtOpen ] = useState(false);
  const [ automationsMgmtOpen, setAutomationsMgmtOpen ] = useState(false);
  const [ tier2MgmtOpen, setTier2MgmtOpen ] = useState(false);
  const [ tier3MgmtOpen, setTier3MgmtOpen ] = useState(false);
  const [ entityEditOpen, setEntityEditOpen ] = useState(false);
  const [ productsEditOpen, setProductsEditOpen ] = useState(false);
  const [ automationsEditOpen, setAutomationsEditOpen ] = useState(false);
  const [ tier2EditOpen, setTier2EditOpen ] = useState(false);
  const [ tier3EditOpen, setTier3EditOpen ] = useState(false);
  const [ entityRenewOpen, setEntityRenewOpen ] = useState(false);
  const [ productsRenewOpen, setProductsRenewOpen ] = useState(false);
  const [ automationsRenewOpen, setAutomationsRenewOpen ] = useState(false);
  const [ tier2RenewOpen, setTier2RenewOpen ] = useState(false);
  const [ tier3RenewOpen, setTier3RenewOpen ] = useState(false);
  const [ planUpdating, setPlanUpdating ] = useState(false);
  const [ methods, setMethods ] = useState<any>({ isLoading: true, data: [] });
  const [ apiMode, setApiMode ] = useState('Call');

  const handleTabSwitch = (type: string) => {
    if (type === 'Call') {
      setApiMode('Call');
    }
    if (type === 'Bundle') {
      setApiMode('Bundle');
    }
  };

  const entityPrice = process.env.REACT_APP_ENTITY_METER_PRICE!;
  const productsPrice = process.env.REACT_APP_PRODUCTS_METER_PRICE!;
  const automationsPrice = process.env.REACT_APP_AUTOMATIONS_METER_PRICE!;
  const tier2Price = process.env.REACT_APP_TIER_2_PRICE!;
  const tier3Price = process.env.REACT_APP_TIER_3_PRICE!;

  const [ entityApi, setEntityApi ] = useState({
    type: 'entity',
    active: false,
    subType: 'metered',
    sub_id: '',
    subItemId: '',
    willCancel: false,
    price: '',
    pay_method: ''
  });
  const [ productsApi, setProductsApi ] = useState({
    type: 'product',
    active: false,
    subType: 'metered',
    sub_id: '',
    subItemId: '',
    willCancel: false,
    price: '',
    pay_method: ''
  });
  const [ automationsApi, setAutomationsApi ] = useState({
    type: 'automation',
    active: false,
    subType: 'metered',
    sub_id: '',
    subItemId: '',
    willCancel: false,
    price: '',
    pay_method: ''
  });
  const [ tier2Api, setTier2Api ] = useState({
    type: 'tier2',
    active: false,
    subType: 'licensed',
    sub_id: '',
    subItemId: '',
    willCancel: false,
    price: '',
    pay_method: ''
  });
  const [ tier3Api, setTier3Api ] = useState({
    type: 'tier3',
    active: false,
    subType: 'licensed',
    sub_id: '',
    subItemId: '',
    willCancel: false,
    price: '',
    pay_method: ''
  });

  const convertTimestamp = (time: any) => {
    if (time === null) {
      return null;
    }
    let date: any = new Date(time * 1000);
    date = `${date.getMonth() + 1 }/${ date.getDate() }/${ date.getFullYear()}`;
    return date;
  };

  const sortApiSubs = (apiSubArray: any) => {
    apiSubArray?.data?.map((sub: any) => {
      if (sub.metadata.moduleName === 'Public API Entity API Subscription') {
        setEntityApi({
          type: 'entity',
          active: true,
          subType: sub.plan.usage_type,
          sub_id: sub.id,
          subItemId: sub.items.data[0].id,
          willCancel: convertTimestamp(sub.cancel_at),
          price: (sub.plan.amount / 100).toFixed(2),
          pay_method: sub.default_payment_method
        });
      }
      if (sub.metadata.moduleName === 'Public API Commodity API Subscription') {
        setProductsApi({
          type: 'product',
          active: true,
          subType: sub.plan.usage_type,
          sub_id: sub.id,
          subItemId: sub.items.data[0].id,
          willCancel: convertTimestamp(sub.cancel_at),
          price: (sub.plan.amount / 100).toFixed(2),
          pay_method: sub.default_payment_method
        });
      }
      if (sub.metadata.moduleName === 'Automations') {
        setAutomationsApi({
          type: 'automation',
          active: true,
          subType: sub.plan.usage_type,
          sub_id: sub.id,
          subItemId: sub.items.data[0].id,
          willCancel: convertTimestamp(sub.cancel_at),
          price: (sub.plan.amount / 100).toFixed(2),
          pay_method: sub.default_payment_method
        });
      }
      if (sub.metadata.moduleName === 'Tier 2') {
        setTier2Api({
          type: 'tier2',
          active: true,
          subType: sub.plan.usage_type,
          sub_id: sub.id,
          subItemId: sub.items.data[0].id,
          willCancel: convertTimestamp(sub.cancel_at),
          price: (sub.plan.amount / 100).toFixed(2),
          pay_method: sub.default_payment_method
        });
      }
      if (sub.metadata.moduleName === 'Tier 3') {
        setTier3Api({
          type: 'tier3',
          active: true,
          subType: sub.plan.usage_type,
          sub_id: sub.id,
          subItemId: sub.items.data[0].id,
          willCancel: convertTimestamp(sub.cancel_at),
          price: (sub.plan.amount / 100).toFixed(2),
          pay_method: sub.default_payment_method
        });
      }
    });
  };

  const getCusPaymentMethods = async(cus_id: string) => {
    const payMethods = await PaymentsAPI.getCustomerPaymentMethods(cus_id);
    if (payMethods?.success) {
      setMethods({ isLoading: false, data: payMethods?.result });
    }
  };

  useEffect(() => {
    sortApiSubs(apiSubs);
  }, [ apiSubs ]);

  useEffect(() => {
    if (cusId) {
      getCusPaymentMethods(cusId);
    }
  }, [ cusId ]);

  const createSubscription = async(cus_id: string, pay_method: string, tier: string) => {
    setPlanUpdating(true);
    const entityObj = {
      lineItems: [
        {
          price: entityPrice,
        }
      ],
      metadata: {
        moduleName: 'People / Companies',
        type: 'api'
      }
    };
    const productObj = {
      lineItems: [
        {
          price: productsPrice,
        }
      ],
      metadata: {
        moduleName: 'Products',
        type: 'api'
      }
    };
    const automationObj = {
      lineItems: [
        {
          price: automationsPrice,
        }
      ],
      metadata: {
        moduleName: 'Automations',
        type: 'api'
      }
    };
    const tier2Obj = {
      lineItems: [
        {
          price: tier2Price,
          quantity: 1
        }
      ],
      metadata: {
        moduleName: 'Tier 2',
        type: 'api'
      }
    };
    const tier3Obj = {
      lineItems: [
        {
          price: tier3Price,
          quantity: 1
        }
      ],
      metadata: {
        moduleName: 'Tier 3',
        type: 'api'
      }
    };
    if (tier === 'entity') {
      const res = await PaymentsAPI.createSubscription(
        cus_id,
        entityObj,
        pay_method
      );
      if (res.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'product') {
      const res = await PaymentsAPI.createSubscription(
        cus_id,
        productObj,
        pay_method
      );
      if (res.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'automation') {
      const res = await PaymentsAPI.createSubscription(
        cus_id,
        automationObj,
        pay_method
      );
      if (res.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'tier2') {
      const res = await PaymentsAPI.createSubscription(
        cus_id,
        tier2Obj,
        pay_method
      );
      if (res.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
    if (tier === 'tier3') {
      const res = await PaymentsAPI.createSubscription(
        cus_id,
        tier3Obj,
        pay_method
      );
      if (res.success) {
        setPlanUpdating(false);
        history.go(0);
      }
    }
  };

  const subscribePublicAPI = async(type: 'entity' | 'product', payment_method: string) => {
    setPlanUpdating(true);
    let result: { success: boolean; message: string; result: any } = {
      success: false,
      message: '',
      result: undefined,
    };
    if (type === 'entity') {
      result = await PaymentsAPI.subscribeEntitiesPublicAPI({
        team_name: cur_user.selected_team.name ?? '',
        email: cur_user.basics.email ?? '',
        payment_method: payment_method
      }).finally(() => {
        setPlanUpdating(false);
      });
    } else if (type === 'product') {
      result = await PaymentsAPI.subscribeCommoditiesPublicAPI({
        team_name: cur_user.selected_team.name ?? '',
        email: cur_user.basics.email ?? '',
        payment_method: payment_method
      }).finally(() => {
        setPlanUpdating(false);
      });
    }else {
      setPlanUpdating(false);
    }

    if (result.success) {
      history.go(0);
    }
  };

  const toggleDrawer = (newOpen: boolean, type: string) => () => {
    switch (type) {
    case 'Entity':
      setEntityEditOpen(newOpen);
      break;
    case 'Products':
      setProductsEditOpen(newOpen);
      break;
    case 'Automations':
      setAutomationsEditOpen(newOpen);
      break;
    case 'Tier 2':
      setTier2EditOpen(newOpen);
      break;
    case 'Tier 3':
      setTier3EditOpen(newOpen);
      break;
    default:
      return;
    }
  };

  return (
    <div className='meter-cont'>
      <div className='meter-head'>
        <div className='meter-head-text-group'>
          <div className='meter-head-badge'>
            <div className='meter-head-title'>
              API Plans
            </div>
            <div className='meter-head-tabs'>
              <div className={`meter-head-tab${apiMode === 'Call' ? '-selected' : ''}`} onClick={() => handleTabSwitch('Call')}>
                <div className={`meter-head-tab-text${apiMode === 'Call' ? '-selected' : ''}`}>
                  Per call
                </div>
              </div>
              <div className={`meter-head-tab${apiMode === 'Bundle' ? '-selected' : ''}`} onClick={() => handleTabSwitch('Bundle')}>
                <div className={`meter-head-tab-text${apiMode === 'Bundle' ? '-selected' : ''}`}>
                  Bundles
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {apiMode === 'Call' && (
        <div className='meter-body-container'>
          <MeterCard
            title='People & Companies'
            price1='0.12'
            price2='0.09'
            price3='0.05'
            price4='0.03'
            interval='per call'
            subtitle='Global Watchlist Screening'
            features={{
              0: 'US & EU Denied Parties',
              1: 'PEP & Beneficial Ownership',
              2: 'Forced Labor Entities',
            }}
            subData={entityApi}
            setMgmtOpen={setEntityMgmtOpen}
            setEditOpen={setEntityEditOpen}
            setCancelOpen={setEntityCancelMode}
            setRenewOpen={setEntityRenewOpen}
            active={true}
          />
          <MeterCard
            title='Commodity & Products'
            price1='0.25'
            price2='0.15'
            price3='0.11'
            price4='0.05'
            interval='per call'
            subtitle='High Risk Trade Checks'
            features={{
              0: 'AD/CVD & CPG-PGA Flags',
              1: 'Chinese & Russian Tariffs/Sanctions',
              2: 'TARIC, Dual-Use, ESG'
            }}
            subData={productsApi}
            setMgmtOpen={setProductsMgmtOpen}
            setEditOpen={setProductsEditOpen}
            setCancelOpen={setProductsCancelMode}
            setRenewOpen={setProductsRenewOpen}
            active={true}
          />
          <MeterCard
            title='Documents & Forms'
            price1='0.70'
            price2='0.50'
            price3='0.20'
            price4='0.10'
            interval='per call'
            subtitle='ACE Form Screening for Risk'
            features={{
              0: 'ABI Forms (Entry, FTZ, GBI, etc.)',
              1: 'Bill of Material & Bill of Lading',
              2: 'Supply & Vendor Screening'
            }}
            subData={automationsApi}
            setMgmtOpen={setAutomationsMgmtOpen}
            setEditOpen={setAutomationsEditOpen}
            setCancelOpen={setAutomationsCancelMode}
            setRenewOpen={setAutomationsRenewOpen}
            active={false}
          />
        </div>
      )}
      {apiMode === 'Bundle' && (
        <div className='meter-body-container'>
          <MeterCard
            title='BITE API Bundle'
            price1='Unlimited'
            price2='Unlimited'
            price3='Unlimited'
            price4='Unlimited'
            priceBundle='25,000'
            interval='per month'
            subtitle='Inclues:'
            features={{
              0: 'Unlimited People & Companies Screens',
              1: 'Unlimited Commodity & Product Transaction Screens',
              2: 'Unlimited Document Screens per Month'
            }}
            subData={tier2Api}
            setMgmtOpen={setTier2MgmtOpen}
            setEditOpen={setTier2EditOpen}
            setCancelOpen={setTier2CancelMode}
            setRenewOpen={setTier2RenewOpen}
            active={false}
          />
          {/* <MeterCard
            title='Tier 3 Bundle'
            price='6,500'
            interval='per month'
            subtitle='Includes'
            features={{
              0: 'Unlimited People & Companies Screens',
              1: 'Unlimited Commodity & Product Transaction Screens',
              2: '5,000 Document Screens per Month'
            }}
            subData={tier3Api}
            setMgmtOpen={setTier3MgmtOpen}
            setEditOpen={setTier3EditOpen}
            setCancelOpen={setTier3CancelMode}
            setRenewOpen={setTier3RenewOpen}
            active={false}
          /> */}
        </div>
      )}
      <Modal
        open={entityRenewOpen}
        onClose={() => setEntityRenewOpen(false)}
      >
        <RenewAPIPlanModal renewInfo={entityRenewOpen} subId={entityApi.sub_id} setRenewOpen={setEntityRenewOpen} />
      </Modal>
      <Modal
        open={productsRenewOpen}
        onClose={() => setProductsRenewOpen(false)}
      >
        <RenewAPIPlanModal renewInfo={productsRenewOpen} subId={productsApi.sub_id} setRenewOpen={setProductsRenewOpen} />
      </Modal>
      <Modal
        open={automationsRenewOpen}
        onClose={() => setAutomationsRenewOpen(false)}
      >
        <RenewAPIPlanModal renewInfo={automationsRenewOpen} subId={automationsApi.sub_id} setRenewOpen={setAutomationsRenewOpen} />
      </Modal>
      <Modal
        open={tier2RenewOpen}
        onClose={() => setTier2RenewOpen(false)}
      >
        <RenewAPIPlanModal renewInfo={tier2RenewOpen} subId={tier2Api.sub_id} setRenewOpen={setTier2RenewOpen} />
      </Modal>
      <Modal
        open={tier3RenewOpen}
        onClose={() => setTier3RenewOpen(false)}
      >
        <RenewAPIPlanModal renewInfo={tier3RenewOpen} subId={tier3Api.sub_id} setRenewOpen={setTier3RenewOpen} />
      </Modal>
      <Modal
        open={entityCancelMode.active}
        onClose={() => setEntityCancelMode({ active: false, cancelNow: false })}
      >
        <CancelAPIModal cancelInfo={entityCancelMode} subId={entityApi.sub_id} setCancelMode={setEntityCancelMode} />
      </Modal>
      <Modal
        open={productsCancelMode.active}
        onClose={() => setProductsCancelMode({ active: false, cancelNow: false })}
      >
        <CancelAPIModal cancelInfo={productsCancelMode} subId={productsApi.sub_id} setCancelMode={setProductsCancelMode} />
      </Modal>
      <Modal
        open={automationsCancelMode.active}
        onClose={() => setAutomationsCancelMode({ active: false, cancelNow: false })}
      >
        <CancelAPIModal cancelInfo={automationsCancelMode} subId={automationsApi.sub_id} setCancelMode={setAutomationsCancelMode} />
      </Modal>
      <Modal
        open={tier2CancelMode.active}
        onClose={() => setTier2CancelMode({ active: false, cancelNow: false })}
      >
        <CancelAPIModal cancelInfo={tier2CancelMode} subId={tier2Api.sub_id} setCancelMode={setTier2CancelMode} />
      </Modal>
      <Modal
        open={tier3CancelMode.active}
        onClose={() => setTier3CancelMode({ active: false, cancelNow: false })}
      >
        <CancelAPIModal cancelInfo={tier3CancelMode} subId={tier3Api.sub_id} setCancelMode={setTier3CancelMode} />
      </Modal>
      <Modal
        open={entityMgmtOpen}
        onClose={() => setEntityMgmtOpen(false)}
      >
        <APISubMgmtModal title='Entity API' price='0.06' handleTabChange={handleTabChange} planUpdating={planUpdating} cusId={cusId} subData={entityApi} methods={methods} createSubscription={createSubscription} setMgmtOpen={setEntityMgmtOpen} subscribePublicAPI={subscribePublicAPI} type={'entity'} />
      </Modal>
      <Modal
        open={productsMgmtOpen}
        onClose={() => setProductsMgmtOpen(false)}
      >
        <APISubMgmtModal title='Products API' price='0.18' handleTabChange={handleTabChange} planUpdating={planUpdating} cusId={cusId} subData={productsApi} methods={methods} createSubscription={createSubscription} setMgmtOpen={setProductsMgmtOpen} subscribePublicAPI={subscribePublicAPI} type={'product'} />
      </Modal>
      <Modal
        open={automationsMgmtOpen}
        onClose={() => setAutomationsMgmtOpen(false)}
      >
        <APISubMgmtModal title='Automations API' price='0.90' handleTabChange={handleTabChange} planUpdating={planUpdating} cusId={cusId} subData={automationsApi} methods={methods} createSubscription={createSubscription} setMgmtOpen={setAutomationsMgmtOpen} />
      </Modal>
      <Modal
        open={tier2MgmtOpen}
        onClose={() => setTier2MgmtOpen(false)}
      >
        <APISubMgmtModal title='Tier 2 Bundle' price='3,720.00' handleTabChange={handleTabChange} planUpdating={planUpdating} cusId={cusId} subData={tier2Api} methods={methods} createSubscription={createSubscription} setMgmtOpen={setTier2MgmtOpen} />
      </Modal>
      <Modal
        open={tier3MgmtOpen}
        onClose={() => setTier3MgmtOpen(false)}
      >
        <APISubMgmtModal title='Tier 3 Bundle' price='6,500.00' handleTabChange={handleTabChange} planUpdating={planUpdating} cusId={cusId} subData={tier3Api} methods={methods} createSubscription={createSubscription} setMgmtOpen={setTier3MgmtOpen} />
      </Modal>
      <Drawer
        open={entityEditOpen}
        onClose={toggleDrawer(false, 'Entity')}
        anchor='right'
      >
        <APIEditPlan setPlanUpdating={setPlanUpdating} setCancelMode={setEntityCancelMode} type='Entity' handleTabChange={handleTabChange} planUpdating={planUpdating} subData={entityApi} methods={methods} toggleDrawer={toggleDrawer} />
      </Drawer>
      <Drawer
        open={productsEditOpen}
        onClose={toggleDrawer(false, 'Products')}
        anchor='right'
      >
        <APIEditPlan setPlanUpdating={setPlanUpdating} setCancelMode={setProductsCancelMode} type='Products' handleTabChange={handleTabChange} planUpdating={planUpdating} subData={productsApi} methods={methods} toggleDrawer={toggleDrawer} />
      </Drawer>
      <Drawer
        open={automationsEditOpen}
        onClose={toggleDrawer(false, 'Automations')}
        anchor='right'
      >
        <APIEditPlan setPlanUpdating={setPlanUpdating} setCancelMode={setAutomationsCancelMode} type='Automations' handleTabChange={handleTabChange} planUpdating={planUpdating} subData={automationsApi} methods={methods} toggleDrawer={toggleDrawer} />
      </Drawer>
      <Drawer
        open={tier2EditOpen}
        onClose={toggleDrawer(false, 'Tier 2')}
        anchor='right'
      >
        <APIEditPlan setPlanUpdating={setPlanUpdating} setCancelMode={setAutomationsCancelMode} type='Tier 2' handleTabChange={handleTabChange} planUpdating={planUpdating} subData={tier2Api} methods={methods} toggleDrawer={toggleDrawer} />
      </Drawer>
      <Drawer
        open={tier3EditOpen}
        onClose={toggleDrawer(false, 'Tier 3')}
        anchor='right'
      >
        <APIEditPlan setPlanUpdating={setPlanUpdating} setCancelMode={setAutomationsCancelMode} type='Tier 3' handleTabChange={handleTabChange} planUpdating={planUpdating} subData={tier3Api} methods={methods} toggleDrawer={toggleDrawer} />
      </Drawer>
    </div>
  );
};

export default APIPlanManagement;
